import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=2691f1c8&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports